export default function Go_Get_Started () {
  return (
    <div>
      <h1>Go_Get_Started </h1>
      <p>Go Get Started</p>
    </div>
  );
}